import React, { useEffect, useState } from 'react';
import './LeftDrawer.scss';
import close from "../../../assets/close.svg"
import tag from "../../../assets/tag-ic.svg"
import home from "../../../assets/home.svg"
import info from "../../../assets/info.svg"
import loc from "../../../assets/location-pin2.svg"
import contact from "../../../assets/phone.svg"
import historyIC from "../../../assets/history.svg"
import search from "../../../assets/search-normal.svg"
import heart from "../../../assets/heart.svg"
import add from "../../../assets/contact.svg"
import gift from "../../../assets/giftbox.svg"
import profile from "../../../assets/user.svg"
import franchise from "../../../assets/franchise.svg"
import voucher from "../../../assets/voucher.svg"
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedOrderType } from '../../../../../../../../redux/resturantWidgetSlice';
import config from "react-global-configuration";



const LeftDrawerV3 = ({ isOpen, setIsOpen, showLogin }) => {
    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const dispatch = useDispatch()
    const company = useSelector((state) => state.companyData.company)
    let selected = localStorage.getItem("selected_cat") ? localStorage.getItem("selected_cat") : "null"
    const pages = useSelector((state) => state.companyData.pages)
    const pageFranchise = pages && pages?.find((page) => page.PageId === "franchise")
    const features = config.get('Theme') !== 'Hospitality-Default-V3-REGAL' ? [
        {
            name: "Track Order",
            img: search,
            link: "/order/track",
            disabled: false
        }, {
            name: "Recent Orders",
            img: historyIC,
            link: "/order/history",
            disabled: false
        },
    ] : [{
        name: "Recent Orders",
        img: historyIC,
        link: "/order/history",
        disabled: false
    },]
    let dataLinkList = [
        {
            name: "Home",
            img: home,
            link: "/",
            disabled: false,
            id: "home"
        },
        // {
        //     name: "Vouchers",
        //     img: voucher,
        //     link: "/vouchers",
        //     disabled: false,
        //     id: "vouchers"

        // },
        {
            name: "Contact",
            img: contact,
            link: "/page/contact",
            disabled: false
        },
        {
            name: "Find Restaurants",
            img: loc,
            link: "/",
            disabled: true
        },
        {
            name: "About Us",
            img: info,
            link: "/",
            disabled: true
        },

        ...(localStorage.getItem('isLogged') === 'true' ? features : [])
    ];
    const [dataLink, setDataLink] = useState(dataLinkList)


    useEffect(() => {
        if (company?.Settings?.Pages?.IncludePages && pageFranchise) {
            let page = {
                name: "Franchise",
                img: franchise,
                link: "/page/franchise",
                disabled: false,
                id: "franchise"
            }
            const newDataLink = dataLinkList?.find((value) => value.id !== page.id) ? [dataLinkList[0], page, ...dataLinkList.slice(1)] : dataLinkList;
            setDataLink(newDataLink)
        } else {
            setDataLink(dataLinkList)
        }
    }, [company, selectedOrderType])
    let guestData = features
    let membersData = [
        {
            name: "Favorites",
            img: heart
        },
        {
            name: "Saved Address",
            img: add
        },
        {
            name: "Rewards",
            img: gift
        },
    ]
    const history = useHistory()
    const toggleDrawer = () => setIsOpen(!isOpen);
    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/'
    };
    return (
        <div className='LeftDrawer'>

            {isOpen && <div className="drawer-overlay" onClick={toggleDrawer} />}

            <div className={`left-drawer ${isOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <img alt='' src={close} className="close-button" onClick={toggleDrawer} />
                    <div className='Left-drawer-header'>Menu</div>
                </div>
                <div className="drawer-content">
                    <div className='profile-drawer-content'>
                        <div className='prof-continer-drawer'>
                            <div className='user-dp-con'>
                                <img alt='' src={profile} className="profile-ic" />
                            </div>
                            <div className='user-name-cont'>
                                <div className='wlcm-hdr'>Welcome, {localStorage.getItem('isLogged') === 'true' ? JSON.parse(localStorage.getItem('fullUserDetails'))?.FirstName : "Guest"}</div>
                                {localStorage.getItem('isLogged') === 'true' ?
                                    <div className='wlcm-sign'>
                                        <div className='wlcm-txt' onClick={handleLogout}>Logout</div></div> : <div className='wlcm-sign'>
                                        <div className='wlcm-txt'
                                            onClick={() => {
                                                showLogin()
                                            }}>Sign In</div>
                                        <div className='wlcm-sp' />
                                        <div className='wlcm-txt'
                                            onClick={() => {
                                                history.push({
                                                    pathname: "/account/register",
                                                    state: { from: "home" }
                                                })
                                            }}>Register</div>

                                    </div>
                                }
                            </div>
                        </div>
                        <div className='prof-cont'>
                            Sign in to access your order history, saved addresses, and exclusive offers!
                        </div>
                    </div>
                    <div className='left-menu'>
                        <div className='left-menu-header'>Explore</div>
                        {dataLink.map((val, key) => {
                            return (
                                <div key={key} className={`left-menu-item ${selected === val.id ? "selected" : val.disabled ? "disable" : ""}`}
                                    onClick={() => {
                                        if (!val.disabled) {
                                            history.push(val.link)
                                            if (val.link === "/vouchers") {
                                                dispatch(setSelectedOrderType("collection"))
                                            }
                                        }
                                    }}>
                                    <img alt='' src={val.img} className={val?.img?.includes(".svg") ? 'left-menu-item-icon' : 'left-menu-item-image'} />
                                    <div className='left-menu-item-header '>
                                        {val.name}</div></div>
                            )
                        })}
                    </div>
                    {localStorage.getItem('isLogged') !== 'true' && <div className='left-menu'>
                        <div className='left-menu-header'>Guest Features</div>
                        {guestData.map((val, key) => {
                            return (
                                <div key={key} className='left-menu-item '
                                    onClick={() => {
                                        history.push(val.link)
                                    }}>
                                    <img alt='' src={val.img} className='left-menu-item-icon' />
                                    <div className='left-menu-item-header '>
                                        {val.name}</div>
                                    <div className='guest-tag'>Guest</div></div>
                            )
                        })}
                    </div>}
                    <div className='left-menu disabled'>
                        <div className='left-menu-header'>Member Features</div>
                        {membersData.map((val, key) => {
                            return (
                                <div key={key} className='left-menu-item '>
                                    <img alt='' src={val.img} className='left-menu-item-icon' />
                                    <div className='left-menu-item-header '>
                                        {val.name}</div>
                                    <div className='members-tag'>Members Only</div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='support-container'>
                        <div className='support-hdr'>Need Help?</div>
                        <div className='support-sub-hdr'>Our customer service team is here to help you</div>
                        <div className='support-btn'>Contact Support</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeftDrawerV3;
